export var EmbedPlacement;
(function (EmbedPlacement) {
    EmbedPlacement["CaseworkerWebCreditorPage"] = "CASEWORKER_WEB_CREDITOR_PAGE";
    EmbedPlacement["CaseworkerWebCasePage"] = "CASEWORKER_WEB_CASE_PAGE";
    EmbedPlacement["CaseworkerWebMenuItem"] = "CASEWORKER_WEB_MENU_ITEM";
    EmbedPlacement["CreditorWebCasePage"] = "CREDITOR_WEB_CASE_PAGE";
    EmbedPlacement["CreditorWebMenuItem"] = "CREDITOR_WEB_MENU_ITEM";
    EmbedPlacement["CreditorWebFrontPage"] = "CREDITOR_WEB_FRONT_PAGE";
})(EmbedPlacement || (EmbedPlacement = {}));
export const getEmbedAreas = (embeds, embedPlacement) => {
    const areas = Object.values(embeds).reduce((acc, arr) => acc.concat(arr), []);
    return embedPlacement
        ? areas.filter((area) => area.placement === embedPlacement)
        : areas;
};
//# sourceMappingURL=index.js.map